import React from 'react';

const DrawerContext = React.createContext('drawer');

export default DrawerContext;
